import carouselSlider from '../components/carousel-slider';
import comparisonSlider from '../components/comparison-slider';

export default {
  init() {
    // JavaScript to be fired on single blog pages
    comparisonSlider();
    carouselSlider();
  },
  finalize() {
    // JavaScript to be fired on single pages, after page specific JS is fired
  },
};
